// Widget Scripts
import swiperWidget from './js/widgets/swiperWidget.js'
import cardWidgetTiles from './js/widgets/cardWidgetTiles.js';
import cardWidgetRedTiles from './js/widgets/cardWidgetRedTiles.js';
import cardWidgetSponsors from './js/widgets/cardWidgetSponsors.js';
import { instafeed, facebookfeed } from './js/widgets/socialNetworkWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import cardWidgetTitle from './js/widgets/cardWidgetTitle.js';
import videoWidget from './js/widgets/videoWidget.js';
import cardWidgetFooterParagraph from './js/widgets/cardWidgetFooterParagraph.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  const hasEventsMode = $('body').hasClass('eventsMode') ? true : false;
  $(document).ready(function() {
    cardWidgetTiles();
    cardWidgetRedTiles();
    cardWidgetSponsors();
    instafeed();
    facebookfeed(true);
    multiScheduleFeature();
    cssSponsors();
    cardWidgetTitle();
    cardWidgetFooterParagraph();

    if (hasEventsMode) {
      $(window).load(function() {
        videoWidget();
      });
    }
    else {
      swiperWidget();
    };
  });
}